const assetTypes = {
  PUBLISHABLE: 'publishable',
};

export default assetTypes;
